//Imports
import React, { useEffect, useState } from "react";
import Select, { components } from 'react-select';
import DatePicker from "react-datepicker";
//Import Contexts
import staticData from '../../../contexts/staticData.json';
//Imports Helpers
import { formatCurrency, getUpdatedEffectiveBalance, getUpdatedEffectiveExpense } from "../../../shared/helpers";
//Imports Icons
import addPME from '../../../assets/icons/pmeWhite.svg';
import downArrow from '../../../assets/icons/downArrow.svg';
import calendar from '../../../assets/icons/calendar.svg';
//Import CSS
import './addPmeActivity.css';

function AddPMEActivity({ setShowPmeActivities, selectedYear, onAddActivity, initialActivity, viewMode, onCloseForm }) {
    const [error, setError] = useState('');
    const [formData, setFormData] = useState({
        dimension: '',
        nameOfAction: '',
        descriptionOfAction: '',
        subdimension: '',
        startDate: null,
        endDate: null,
        resources: '',
        subsidies: {
            general: 0,
            sep: 0,
            pie: 0,
            eib: 0,
            maintenance: 0,
            retention: 0,
            internship: 0,
            reinforcement: 0,
            faep: 0
        },
        totalSubsidyAmount: 0,
        accruedExpense: 0,
        effectiveExpense: 0,
        accruedBalance: 0,
        effectiveBalance: 0
    });

    const subsidyNames = {
        general: 'General',
        sep: 'SEP',
        pie: 'PIE',
        eib: 'EIB',
        maintenance: 'Mantenimiento',
        retention: 'Pro Retención',
        internship: 'Internado',
        reinforcement: 'Reforzamiento',
        faep: 'FAEP'
    };

    const fieldLabels = {
        dimension: 'Dimensión',
        nameOfAction: 'Nombre de la Acción',
        descriptionOfAction: 'Descripción',
        // clasificationOfAction: 'Clasificación',
        subdimension: 'Subdimensión',
        startDate: 'Fecha Inicio',
        endDate: 'Fecha Término',
        resources: 'Recursos Requeridos'
    };

    useEffect(() => {
        if (initialActivity) {
            setFormData({
                ...initialActivity
            });
        }
    }, [initialActivity]);

    useEffect(() => {
        const total = Object.values(formData.subsidies).reduce((sum, value) => sum + value, 0);
        setFormData(prevState => ({
            ...prevState,
            totalSubsidyAmount: total
        }));
    }, [formData.subsidies]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (Object.keys(formData.subsidies).includes(name)) {
            setFormData(prevState => ({
                ...prevState,
                subsidies: {
                    ...prevState.subsidies,
                    [name]: value
                }
            }));
        } else {
            setFormData(prevState => ({
                ...prevState,
                [name]: value
            }));
        }
    };

    const handleSelectChange = (selectedOption, { name }) => {
        setFormData(prevState => ({
            ...prevState,
            [name]: selectedOption.value
        }));
    };

    const handleDateChange = (date, name) => {
        setFormData(prevState => {
            // Si estamos cambiando la fecha de inicio y la fecha de fin existe y es anterior a la nueva fecha de inicio
            if (name === 'startDate' && prevState.endDate && prevState.endDate < date?.getTime()) {
                // Resetear la fecha de fin ya que ahora sería inválida
                return {
                    ...prevState,
                    [name]: date ? date.getTime() : null,
                    endDate: null
                };
            }
            
            return {
                ...prevState,
                [name]: date ? date.getTime() : null
            };
        });
    };

    const handleSubsidyChange = (e) => {
        const { name, value } = e.target;
        let numericValue = parseInt(value.replace(/[^\d]/g, ''), 10) || 0;

        setFormData(prevState => ({
            ...prevState,
            subsidies: {
                ...prevState.subsidies,
                [name]: numericValue
            }
        }));
    };
    const validateForm = () => {
        const requiredFields = ['dimension', 'nameOfAction', 'descriptionOfAction', 'dimension', 'startDate', 'endDate', 'resources'];
        const emptyFields = requiredFields.filter(field => !formData[field]);

        if (emptyFields.length > 0) {
            setError(`Debes llenar todos los campos: ${emptyFields.map(field => fieldLabels[field]).join(', ')}`);
            return false;
        }

        if (formData.totalSubsidyAmount === 0) {
            setError('Debes llenar todos los campos: Ingresa monto de subvención');
            return false;
        }

        setError('');
        return true;
    };



    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            // Primero calculamos los nuevos valores
            const updatedEffectiveExpense = getUpdatedEffectiveExpense(formData);
            const updatedEffectiveBalance = getUpdatedEffectiveBalance(formData);

            // Actualizamos el formData con los nuevos valores
            const updatedFormData = {
                ...formData,
                effectiveExpense: updatedEffectiveExpense,
                effectiveBalance: updatedEffectiveBalance
            };

            // Una vez actualizado el formData, llamamos a onAddActivity
            setFormData(updatedFormData);
            onAddActivity(updatedFormData);
            setShowPmeActivities(false);
        }
    };

    const getCurrentDateInSelectedYear = () => {
        const currentDate = new Date();
        return new Date(selectedYear, currentDate.getMonth(), currentDate.getDate());
    };

    const startDate = getCurrentDateInSelectedYear();
    const orderedSubsidies = Object.keys(subsidyNames);

    return (
        <form className='form-add-pme-activity show flex' onSubmit={handleSubmit}>
            <span className='container flex'>
                <article className='input-select flex'>
                    <label htmlFor='dimension' className='label-region'>Dimensión (*)</label>
                    <Select
                        name='dimension'
                        id='dimension'
                        options={staticData.dimensionAction.map((dimension) => ({
                            value: dimension,
                            label: dimension
                        }))
                            .sort((a, b) => a.label.localeCompare(b.label))
                        }
                        placeholder='Seleccionar Establecimiento'
                        className={`custom-select ${viewMode ? 'view-mode' : ''}`}
                        classNamePrefix='custom-select'
                        components={{ DropdownIndicator }}
                        onChange={(selectedOption) => handleSelectChange(selectedOption, { name: 'dimension' })}
                        value={formData?.dimension ? { value: formData.dimension, label: formData.dimension } : null}
                        isDisabled={viewMode}
                    />
                </article>
                <article className='input-box'>
                    <label htmlFor='nameOfAction' className='label'>Nombre de la Acción (*)</label>
                    <input
                        type='text'
                        id='nameOfAction'
                        name='nameOfAction'
                        className='input'
                        placeholder='Ingrese nombre de la acción'
                        value={formData.nameOfAction}
                        onChange={handleInputChange}
                        disabled={viewMode}
                    />
                </article>
                <article className='input-box'>
                    <label htmlFor='descriptionOfAction' className='label'>Descripción (*)</label>
                    <input
                        type='text'
                        id='descriptionOfAction'
                        name='descriptionOfAction'
                        className='input'
                        placeholder='Ingrese nombre de la acción'
                        value={formData.descriptionOfAction}
                        onChange={handleInputChange}
                        disabled={viewMode}
                    />
                </article>
                <article className='input-select flex'>
                    <label htmlFor='subdimension' className='label'>Subdimensión (*)</label>
                    <Select
                        name='subdimension'
                        id='subdimension'
                        options={staticData.subdimensions.map((subdimension) => ({
                            value: subdimension,
                            label: subdimension
                        }))
                            .sort((a, b) => a.label.localeCompare(b.label))
                        }
                        placeholder='Selecciona'
                        className={`custom-select ${viewMode ? 'view-mode' : ''}`}
                        classNamePrefix='custom-select'
                        components={{ DropdownIndicator }}
                        onChange={(selectedOption) => handleSelectChange(selectedOption, { name: 'subdimension' })}
                        value={formData.subdimension ? { value: formData.subdimension, label: formData.subdimension } : null}
                        isDisabled={viewMode}
                    />
                </article>
                <article className='input-select flex'>
                    <label htmlFor='startDate' className='label-region'>Fecha Inicio (*)</label>
                    <DatePicker
                        selected={formData?.startDate ? new Date(formData.startDate) : null}
                        onChange={(date) => handleDateChange(date, 'startDate')}
                        className='custom-date-input'
                        dateFormat='dd-MM-yyyy'
                        placeholderText='Selecciona una fecha'
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        openToDate={startDate}
                        disabled={viewMode}
                    />
                    <img src={calendar} className='icon' alt='Icono calendario' />
                </article>
                <article className='input-select flex'>
                    <label htmlFor='endDate' className='label-region'>Fecha Término (*)</label>
                    <DatePicker
                        selected={formData?.endDate ? new Date(formData.endDate) : null}
                        onChange={(date) => handleDateChange(date, 'endDate')}
                        className='custom-date-input'
                        dateFormat='dd-MM-yyyy'
                        minDate={formData.startDate ? new Date(formData.startDate) : null}
                        placeholderText='Selecciona una fecha'
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        openToDate={startDate}
                        disabled={viewMode}
                    />
                    <img src={calendar} className='icon' alt='Icono calendario' />
                </article>
            </span>
            <article className='input-box'>
                <label htmlFor='resources' className='label'>Recursos Requeridos (*)</label>
                <input
                    type='text'
                    id='resources'
                    name='resources'
                    className='input'
                    placeholder='Ingrese los recursos necesarios para llevar a cabo esta Acción'
                    value={formData.resources}
                    onChange={handleInputChange}
                    disabled={viewMode}
                />
            </article>
            <table className='subsidy-table'>
                <thead className='header-table'>
                    <tr className='flex'>
                        <th>Tipo de Subvención</th>
                        <th>Monto</th>
                    </tr>
                </thead>
                <tfoot className='foot-table'>
                    <tr className='flex'>
                        <td>Totales</td>
                        <td>{formatCurrency(formData.totalSubsidyAmount)}</td>
                    </tr>
                </tfoot>
                <tbody className='body-table'>
                    {orderedSubsidies.map(key => (
                        <tr key={key} className='flex'>
                            <td>{subsidyNames[key]}</td>
                            <td>
                                <span className='input-box'>
                                    <label htmlFor={key} className='label-hidden'>Monto {subsidyNames[key]}</label>
                                    <input
                                        type='text'
                                        id={key}
                                        name={key}
                                        className='input'
                                        placeholder='Ingrese monto'
                                        value={formatCurrency(formData.subsidies[key])}
                                        onChange={handleSubsidyChange}
                                        disabled={viewMode}
                                    />
                                </span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {error && <p className="error-message">{error}</p>}
            <article className='box-actions flex'>
                {!viewMode && (
                    <button type='submit' className='box-button flex'>
                        <img src={addPME} className='icon' alt='Icono para agregar nueva acción' />
                        <p>{initialActivity ? 'Actualizar Acción' : 'Agregar Nueva Acción'}</p>
                    </button>
                )}
                <p className='button-cancel' onClick={onCloseForm}>{viewMode ? 'Cerrar' : 'Cancelar'}</p>
            </article>
        </form>
    )
};

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <img src={downArrow} alt="CustomArrow" />
        </components.DropdownIndicator>
    );
};

export default AddPMEActivity;